import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import Home from "./components/Home";

ReactDOM.render(
  <React.Fragment>
    <Home />
  </React.Fragment>,
  document.getElementById("app")
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // When a new service worker is available, automatically activate it
    if (registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      // Reload the page to use the new service worker
      window.location.reload();
    }
  },
});
